import * as React from "react";
import type { SVGProps } from "react";
const SvgLogoSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={96}
    height={30}
    fill="none"
    viewBox="0 0 1920 607"
    {...props}
  >
    <path
      fill="url(#logo-small_svg__a)"
      d="M4.442 474.994h13.28c21.356 0 40.693-8.659 54.69-22.657 14.044-13.998 22.658-33.335 22.658-54.691v-72.593c0-12.876 6.146-24.362 15.703-31.63a4.448 4.448 0 0 0 2.019-3.724 4.423 4.423 0 0 0-4.442-4.441H95.07c-21.356 0-40.693 8.614-54.691 22.612-13.998 14.043-22.657 33.38-22.657 54.736v72.547c0 12.921-6.192 24.452-15.748 31.72a.9.9 0 0 1-.27.179c-1.031.853-1.704 2.109-1.704 3.5 0 2.468 2.019 4.442 4.442 4.442"
    />
    <path
      fill="url(#logo-small_svg__b)"
      d="M99.152 474.997h13.28c21.356 0 40.693-8.659 54.691-22.657 14.043-13.998 22.657-33.335 22.657-54.691V230.166c0-12.876 6.146-24.362 15.703-31.63a4.445 4.445 0 0 0 2.019-3.724 4.423 4.423 0 0 0-4.442-4.441h-13.28c-21.356 0-40.693 8.614-54.691 22.612-13.998 14.043-22.657 33.38-22.657 54.736v167.438c0 12.921-6.192 24.451-15.748 31.719a1 1 0 0 1-.27.18c-1.031.852-1.704 2.109-1.704 3.499 0 2.468 2.019 4.442 4.442 4.442"
    />
    <path
      fill="url(#logo-small_svg__c)"
      d="M193.774 474.995h13.28c21.356 0 40.693-8.659 54.691-22.657 14.043-13.998 22.657-33.335 22.657-54.691V135.273c0-12.876 6.147-24.361 15.703-31.63a4.444 4.444 0 0 0 2.019-3.724 4.423 4.423 0 0 0-4.441-4.441h-13.281c-21.356 0-40.693 8.614-54.691 22.612-13.998 14.043-22.657 33.38-22.657 54.736v262.328c0 12.921-6.191 24.452-15.747 31.72a.9.9 0 0 1-.27.179c-1.032.853-1.704 2.109-1.704 3.5 0 2.468 2.018 4.442 4.441 4.442"
    />
    <path
      fill="url(#logo-small_svg__d)"
      d="M288.439 474.995h13.28c21.356 0 40.693-8.659 54.691-22.657 14.043-13.998 22.657-33.335 22.657-54.691V40.429c0-12.877 6.146-24.362 15.703-31.63a4.444 4.444 0 0 0 2.019-3.724 4.423 4.423 0 0 0-4.442-4.442h-13.28c-21.356 0-40.693 8.614-54.691 22.612-13.998 14.043-22.657 33.38-22.657 54.736v357.174c0 12.921-6.192 24.451-15.748 31.72a1 1 0 0 1-.269.179c-1.032.852-1.705 2.109-1.705 3.5 0 2.467 2.019 4.441 4.442 4.441"
    />
    <path
      fill="#F7F9FF"
      d="m754.248 103.605-88.382 242.452c-15.707 43.067-51.847 43.067-67.553 0l-88.382-242.452h-69.308l108.362 283.969c15.056 47.041 48.564 64.319 81.76 64.319s63.704-15.727 85.807-66.602l108.164-281.686zM1115.64 141.458c-32.63-30.75-76.61-49.662-124.972-49.662-100.382 0-182.029 81.315-182.029 181.289s81.647 181.289 182.029 181.289c48.362 0 92.342-18.913 124.972-49.664v39.714h58.1V104.479h-58.1zm-124.972 254.12c-67.809 0-122.994-54.933-122.994-122.493 0-67.561 55.158-122.466 122.994-122.466 67.832 0 122.992 54.933 122.992 122.466s-55.16 122.493-122.992 122.493M1862.15 103.889v198.68c0 17.362-4.24 33.118-12.71 47.267-8.37 14.008-19.66 25.113-33.75 33.427-.2.085-.43.17-.63.283-14.06 8.314-29.8 12.486-47.18 12.514-17.38 0-33.11-4.2-47.17-12.514-.23-.142-.43-.198-.62-.283-14.13-8.314-25.39-19.419-33.77-33.427-8.48-14.149-12.71-29.905-12.71-47.267V103.805h-57.76v211.419c0 25.817 6.26 49.212 18.74 70.21s29.34 37.712 50.55 50.17c21.19 12.43 48.33 18.687 88.49 18.687 25.67 0 55.9-6.229 77.09-18.687 21.2-12.429 38.06-29.172 50.55-50.17 12.47-20.998 18.73-44.393 18.73-70.21V103.889zM1514.87 286.166V105.293h60.73v332.29c0 50.685-26.36 86.788-60.73 122.118-32.33 29.392-75.04 47.298-122.25 47.298-9.86 0-19.52-.786-28.95-2.298v-60.315a119 119 0 0 0 28.95 3.576c63.47 0 115.94-48.457 122.25-110.379v-29.298c-32.33 29.392-75.04 47.298-122.25 47.298-47.22 0-90.28-18.048-122.67-47.693-36.4-33.239-59.29-81.131-59.29-134.255V105.406h59.29v176.093c4.08 64.157 59.18 115.047 122.67 115.047 63.47 0 115.94-48.457 122.25-110.38"
    />
    <defs>
      <linearGradient
        id="logo-small_svg__a"
        x1={-62.445}
        x2={-151.384}
        y1={554.122}
        y2={-21.983}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.15} stopColor="#0ACDA7" />
        <stop offset={0.85} stopColor="#0F53F2" />
      </linearGradient>
      <linearGradient
        id="logo-small_svg__b"
        x1={-62.445}
        x2={-151.384}
        y1={554.122}
        y2={-21.983}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.15} stopColor="#0ACDA7" />
        <stop offset={0.85} stopColor="#0F53F2" />
      </linearGradient>
      <linearGradient
        id="logo-small_svg__c"
        x1={-62.445}
        x2={-151.384}
        y1={554.122}
        y2={-21.983}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.15} stopColor="#0ACDA7" />
        <stop offset={0.85} stopColor="#0F53F2" />
      </linearGradient>
      <linearGradient
        id="logo-small_svg__d"
        x1={-62.445}
        x2={-151.384}
        y1={554.122}
        y2={-21.983}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.15} stopColor="#0ACDA7" />
        <stop offset={0.85} stopColor="#0F53F2" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgLogoSmall;
